export default __webpack_public_path__ + "static/media/logoAutomar.4f160575.png";